import { createSignal } from "solid-js";
import Icon from "@lib/components/Icon";
import { Languages } from "@lib/constants";

export default function LanguageSwitch(props) {
	const [lang, setLang] = createSignal(localStorage.lang ?? "en");

	function switchLanguage(val) {
		localStorage.lang = val;
		document.location.reload();
	}

	return (
		<div class="dropdown dropdown-end dropdown-hover">
			<div tabindex="0" role="button" class="btn btn-ghost btn-sm font-normal text-inherit border-none bg-transparent hover:bg-white/10">
				<Icon name="earth-line" size={18} />
				<span class={props.showLabel ? "inline" : "hidden md:inline"}>{Languages[lang()] ?? lang()}</span>
			</div>
			<ul tabindex="0" class="dropdown-content bg-base-100 rounded-md z-[100] w-28 p-1.5 shadow-lg border border-base-300">
				<li>
					<button class={`w-full text-left text-xs px-3 py-1.5 rounded-sm transition-colors ${lang() === 'en' ? 'bg-primary text-primary-content' : 'text-base-content hover:bg-primary/10 hover:text-primary'}`} onClick={() => switchLanguage("en")}>English</button>
				</li>
				<li>
					<button class={`w-full text-left text-xs px-3 py-1.5 rounded-sm transition-colors ${lang() === 'zh-Hant' ? 'bg-primary text-primary-content' : 'text-base-content hover:bg-primary/10 hover:text-primary'}`} onClick={() => switchLanguage("zh-Hant")}>繁體中文</button>
				</li>
				<li>
					<button class={`w-full text-left text-xs px-3 py-1.5 rounded-sm transition-colors ${lang() === 'zh-Hans' ? 'bg-primary text-primary-content' : 'text-base-content hover:bg-primary/10 hover:text-primary'}`} onClick={() => switchLanguage("zh-Hans")}>简体中文</button>
				</li>
			</ul>
		</div>
	);
}
